export default __webpack_public_path__ + "static/media/mars.fab4f050.jpeg";